import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { DialogStateService } from '../../../dialogs/services/dialog-state.service';
import {
  BulkTransferService,
  BULK_TRANSFER_TYPES
} from './../../../transfers/services/bulk-transfer.service';

import { FormFields } from './../../services/form-fields-generator.service';

interface IFileUploadConfiguration {
  allowedExtensions: Array<string>;
  maxFileSize: number;
}

interface IFileInterface {
  file: File;
  format: string;
}

@Component({
  selector: 'ab-file-upload-field',
  templateUrl: './file-upload-field.component.html',
  styleUrls: ['./file-upload-field.component.scss']
})
export class FileUploadFieldComponent implements OnInit {
  @Input()
  public formFields: FormFields;

  @Input()
  public configuration: IFileUploadConfiguration;

  @Output()
  private onFileUpload: EventEmitter<IFileInterface> = new EventEmitter();

  @ViewChild('fileElement')
  fileElement: ElementRef;

  public selectedFile: File = null;
  public fileEmitted: boolean = false;

  public uploadForm = new UntypedFormGroup({
    file: new UntypedFormControl(''),
    format: new UntypedFormControl('', Validators.required)
  });

  public bulkFileStructures: any;

  private defaultConfiguration: IFileUploadConfiguration = {
    allowedExtensions: [],
    maxFileSize: 1000
  };

  private subscription: Subscription;

  get file() {
    return this.uploadForm.get('file');
  }

  get format() {
    return this.uploadForm.get('format');
  }

  constructor(
    private bulkTransferService: BulkTransferService,
    private dialogStateService: DialogStateService
  ) {}

  ngOnInit() {
    this.configuration = Object.assign(
      this.defaultConfiguration,
      this.configuration
    );

    const values = [...this.formFields.fields.bulkFileStructures.values];

    const purposeOptions = {
      [BULK_TRANSFER_TYPES.INTERNATIONAL]: values.splice(2, 1),
      [BULK_TRANSFER_TYPES.DOMESTIC]: values.splice(0, 2)
    };
    this.bulkFileStructures = purposeOptions[BULK_TRANSFER_TYPES.DOMESTIC];

    this.subscription = this.bulkTransferService
      .getPurpose()
      .subscribe(purpose => {
        if (
          this.bulkTransferService.getTransferType(purpose) ===
          BULK_TRANSFER_TYPES.INTERNATIONAL
        ) {
          this.format.disable();
          this.deleteFile();
          this.bulkFileStructures =
            purposeOptions[BULK_TRANSFER_TYPES.INTERNATIONAL];
        } else {
          if (
            this.bulkFileStructures ===
            purposeOptions[BULK_TRANSFER_TYPES.INTERNATIONAL]
          ) {
            this.deleteFile();
          }
          this.format.enable();
          this.bulkFileStructures =
            purposeOptions[BULK_TRANSFER_TYPES.DOMESTIC];
        }

        this.format.setValue(this.bulkFileStructures[0].fields.Value.value);
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openUploadWindow($event: any) {
    $event.preventDefault();
    this.fileElement.nativeElement.click();
  }

  onFilesSelect($event) {
    this.fileEmitted = false;
    let file = $event.target.files[0];
    this.selectedFile = file;
    this.validateFile(file);
  }

  deleteFile() {
    this.selectedFile = null;
    this.file.reset();
    this.emitFile();
  }

  emitFile() {
    this.fileEmitted = true;
    this.onFileUpload.emit({
      file: this.selectedFile,
      format: this.format.value
    });
  }

  openExplainationDialog() {
    this.dialogStateService
      .openDialog('bulkStructureExplainationDialog')
      .subscribe();
  }

  private validateFile(file: File): boolean {
    this.file.markAsDirty();
    return file && this.validateExtension(file) && this.validateSize(file);
  }

  private validateExtension(file: File): boolean {
    let ext = file.name.split('.')[file.name.split('.').length - 1];
    if (
      this.configuration.allowedExtensions.lastIndexOf(ext.toLowerCase()) != -1
    ) {
      return true;
    }

    this.file.setErrors({
      type: true
    });
    return false;
  }

  private validateSize(file: File): boolean {
    if (file.size <= this.configuration.maxFileSize) {
      return true;
    }

    this.file.setErrors({
      size: true
    });
    return false;
  }
}
